import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ArrowRecurringIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { textColorL2 } from '@calendly/ui/theme'

import { HeaderWithIcon, PanelContentContainer, PanelContentHeader } from '../styles'
import { ManagedHoursOptions } from './available_hours/components/availability_options'
import { EventTypeLevelAvailableHours } from './available_hours/event_type_level_available_hours'
import { BaseAvailability } from './base_availability'
import { PanelContentTitle } from './styles'

export const ManagedAvailability = ({ isLocked = false, isReadOnly = false }) => {
  const { values: { userRuleType } } = useFormContext()
  const isExistingUserRuleType = userRuleType === 'existing'

  return (
    <BaseAvailability
      isLocked={isLocked}
      description={I18n.t('publisher.event_type_editor.sections.scheduling_settings.managed_event_types.description')}
    >
      <PanelContentContainer>
        <PanelContentContainer section>
          <PanelContentTitle>
            {I18n.t('publisher.event_type_editor.sections.availability.schedule.title')}
          </PanelContentTitle>
          <ManagedHoursOptions />
        </PanelContentContainer>
        {!isExistingUserRuleType && (
          <PanelContentHeader>
            <HeaderWithIcon>
              <ArrowRecurringIcon color={textColorL2} />
              <BodyText size="medium">
                {I18n.t('publisher.event_type_editor.sections.available_hours.weekly_hours')}
              </BodyText>
            </HeaderWithIcon>
            <BodyText size="x-small" color="muted">
              {I18n.t('publisher.event_type_editor.sections.availability.hours.weekly_hours_for_all')}
            </BodyText>
          </PanelContentHeader>
        )}
      </PanelContentContainer>
      {!isExistingUserRuleType && (
        <EventTypeLevelAvailableHours
          formPath="eventTypeAvailability"
          isManaged
          readOnly={isReadOnly}
        />
      )}
    </BaseAvailability>
  )
}
